<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" sm="4">
                <h1 class="headline font-weight-light mb-3">
                    Posnet Print Return Unit
                </h1>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>

        <v-card class="mt-4">
            <div>
                <v-row>
                    <v-col cols="6" class="text-left">
                        <v-btn
                            small
                            rounded
                            color="primary"
                            @click="open_dialog()"
                            class="ml-1"
                        >
                            <v-icon small>mdi-plus</v-icon>
                            New Unit
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <v-btn
                            :disabled="data_show.length == 0"
                            small
                            rounded
                            color="warning"
                            @click="print_data()"
                            class="mr-1"
                        >
                            <v-icon small>mdi-printer</v-icon>
                            Print
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">
                                            #
                                        </th>
                                        <th class="text-center">
                                            Case ID
                                        </th>
                                        <th class="text-center">
                                            Site Name
                                        </th>
                                        <th class="text-center">
                                            Product
                                        </th>
                                        <th class="text-center">
                                            Serial
                                        </th>
                                        <th class="text-center">
                                            Terminal
                                        </th>
                                        <th class="text-center">
                                            Sympthom
                                        </th>
                                        <th class="text-center">
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, index) in data_show"
                                        :key="index"
                                    >
                                        <td>
                                            {{
                                                data_main.length != index + 1
                                                    ? index + 1 + "."
                                                    : ""
                                            }}
                                        </td>
                                        <td>{{ row.case_id }}</td>
                                        <td>
                                            {{ row.site_province }} -
                                            {{ row.site_name }}
                                        </td>
                                        <td>{{ row.product_no }}</td>
                                        <td>{{ row.serial }}</td>
                                        <td>{{ row.terminal }}</td>
                                        <td>{{ row.sympthom }}</td>
                                        <td>
                                            <v-btn
                                                small
                                                rounded
                                                color="red"
                                                class="text-center"
                                                dark
                                                fab
                                                @click="delete_data(row)"
                                            >
                                                <v-icon small
                                                    >mdi-delete</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <div id="printDiv" v-if="chk_print === true">
            <v-row>
                <v-col
                    cols="5"
                    class="ml-3 mb-2"
                    v-for="(r, i) in data_show"
                    :key="i"
                >
                    <v-row style="border-style: solid !important;">
                        <v-col cols="12" class="text-center">
                            <span style="font-weight: bold; font-size:16px">
                                ใบแจ้งส่งเครื่อง EDC
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                                เลขที่ Job No.
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.case_id }}
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                                ชื่อ บริษัท / ร้าน
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.site_name }}
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                                จังหวัด
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.site_province }}
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                                อุปกรณ์เสีย เครื่องรุ่น
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.product_no }}
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                                Terminal
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.terminal }}
                            </span>
                            <span style="font-weight: bold;">
                                S/N
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.serial }}
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                                อาการเสีย :
                            </span>
                            <span style="border-bottom: 1px solid ;">
                                {{ r.symthom }}
                            </span>
                        </v-col>

                        <v-col cols="3"></v-col>
                        <v-col cols="3" class="text-right">
                            <span style="font-weight: bold;">
                                ชื่อผู้ส่ง
                            </span>
                        </v-col>
                        <v-col
                            cols="6"
                            style="border-bottom: 1px solid ;"
                        ></v-col>
                        <v-col cols="3"></v-col>
                        <v-col cols="3" class="text-right">
                            <span style="font-weight: bold;">
                                หน่วยงาน
                            </span>
                        </v-col>
                        <v-col
                            cols="6"
                            style="border-bottom: 1px solid ;"
                        ></v-col>
                        <v-col cols="3"></v-col>
                        <v-col cols="3" class="text-right">
                            <span style="font-weight: bold;">
                                วันที่
                            </span>
                        </v-col>
                        <v-col
                            cols="6"
                            style="border-bottom: 1px solid ;"
                        ></v-col>

                        <v-col cols="6">
                            <span style="font-size:12px;">
                                Reference : QP-LAB-01
                            </span>
                        </v-col>
                        <v-col cols="6">
                            <span style="font-size:12px;">
                                FM-LAB01-01 Rev.01 2/04/61
                            </span>
                        </v-col>
                    </v-row>

                    <div
                        :style="
                            i + 1 != 1 && (i + 1) % 10 === 0
                                ? 'page-break-before: always;'
                                : ''
                        "
                    ></div>
                </v-col>
            </v-row>
        </div>

        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Search For New Unit</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row v-if="search.step == 1">
                            <v-col cols="12" md="8">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Search / Enter"
                                    v-model="search.search"
                                    v-on:keyup.enter="search_data()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="search.step == 2">
                            <v-col cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Case ID"
                                    v-model="data_search.case_id"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Site Name"
                                    v-model="data_search.site_name"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Product"
                                    v-model="data_search.product_no"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Serial"
                                    v-model="data_search.serial"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Province"
                                    v-model="data_search.site_province"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Terminal ID"
                                    v-model="data_search.terminal"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Sympthom"
                                    v-model="data_search.symthom"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close_dialog()">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        rounded
                        v-if="search.step == 2"
                        @click="save_data()"
                    >
                        <v-icon small class="mr-1">mdi-content-save</v-icon>
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {},
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {},

    computed: {},

    methods: {
        open_dialog() {
            this.dialog = true
        },
        close_dialog() {
            this.search.search = ""
            this.search.step = 1
            this.dialog = false
        },
        async search_data() {
            this.dialog_loading = true
            await axios
                .post(url + "search-posnet-unit", this.search, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_search = response.data
                    this.search.step = 2
                })
                .catch((error) => {
                    console.log(error)
                })
            // this.data_search = {
            //     case_id: "",
            //     site_name: "",
            //     site_province: "",
            //     product_no: "",
            //     terminal: "",
            //     serial: "",
            //     symthom: "",
            // }
            this.search.step = 2
        },
        save_data() {
            this.data_show.push(this.data_search)
            this.close_dialog()
        },
        delete_data(data) {
            const filteredItems = this.data_show.filter(function(item) {
                return item !== data
            })

            this.data_show = filteredItems
        },
        print_data() {
            this.chk_print = true
            this.dialog_loading = true

            if (this.chk_print === true) {
                setTimeout(() => {
                    this.chk_print = false
                    this.$htmlToPaper("printDiv")
                }, 1000)
                setTimeout(() => {
                    this.dialog_loading = false
                }, 1100)
            }
        },
    },
    data() {
        return {
            data_main: [],
            data_show: [],
            dialog: false,
            search: {
                search: "",
                step: 1,
            },
            data_search: {},
            dialog_loading: false,
            chk_print: false,
        }
    },
}
</script>
<style>
.xx {
    font-weight: bold;
}
</style>
